export default __webpack_public_path__ + "static/media/astradental.e4fe9293.jpg";